import React from 'react';
import BasicCardsContainer from '../../Componant/Bonus-Ui/Cards/BasicCards';

const BasicCards = () => {
  return (
    <div className='page-body'>
      <BasicCardsContainer />
    </div>
  );
};

export default BasicCards;
